<template>
  <div id="index">
    <common-header></common-header>
    <!-- メッセージ -->
    <div v-if="isError">
      <v-alert
        :value="true"
        type="error"
        outline
      >
        {{errorMessage}}
      </v-alert>
    </div>
    <!-- /メッセージ -->
    <!-- メッセージ -->
    <div v-if="content.release &&content.coEdit" class="wrapper" style="margin:10px auto 0 auto !important"  @click="onTipAdd">
      <v-alert
        :value="true"
        outline
        color="red accent-1"
        style="margin:0!important;"
      >
        みんなの年表には誰でも出来事を投稿できます。<br>あなたの想い出を投稿してみましょう！！
      </v-alert>
    </div>
    <!-- /メッセージ -->
    <div class="wrapper" v-if="!isLoading">
      <!--サムネイルimage -->
      <div v-if="hasImage" style="text-align:center;margin-bottom:16px;">
        <img v-if="!isImageLoading" :src="imageUrl" style="max-width:90%;max-heght:400px;">
        <div v-else style="height:300px;">
          <v-progress-circular :size="50" :width="5" color="red" indeterminate></v-progress-circular>
        </div>
      </div>
      <v-layout row v-if="!content.release">
        <v-flex xs6><v-chip label dark color="red accent-1" large @click="onEdit">非公開</v-chip></v-flex>
        <v-flex xs6 style="text-align:right">
          <v-btn color="red" outline small @click="onEdit"><v-icon small>edit</v-icon>&nbsp;編集へ</v-btn>
        </v-flex>
      </v-layout>
      <v-layout row v-else-if="content.coEdit">
        <v-flex xs6><v-chip label dark color="red accent-1" large>みんなの年表</v-chip></v-flex>
        <v-flex xs6 style="text-align:right">
          <v-btn color="red" outline small @click="onTipAdd"><v-icon small>edit</v-icon>&nbsp;できごと追加</v-btn>
        </v-flex>
      </v-layout>
      <div style="margin: 16px 0;">
        <h1 class="content-title">{{content.title}}の年表</h1>
        <!--アイコン、名前、投稿日 -->
        <div v-if="content.coEdit">
          <v-badge color="red accent-1" v-for="(u,id) in users" :key="id">
            <span slot="badge">{{u.count}}</span>
            <v-avatar @click="onProfileClick(u.uid)">
              <img :src="u.profileImageUrl">
            </v-avatar>
          </v-badge>
        </div>
        <v-list-tile v-else avatar @click="onProfileClick(content.uid)">
          <v-list-tile-avatar>
            <img :src="content.profileImageUrl">
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title v-html="content.displayName"></v-list-tile-title>
            <v-list-tile-sub-title v-html="displayDate"></v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
      </div>
      <div v-if="content.introduction" class="block" v-html="$options.filters.changeBr(content.introduction)" style="margin-bottom: 16px;"></div>
      <!--年表 Simple-->
      <table v-if="content.type=='simple'">
        <tr v-for="(row,id) in content.rows" :key="id">
          <th class="year">{{row.year | displayYear}}</th>
          <td class="content" v-html="$options.filters.changeBr(row.content)"></td>
        </tr>
      </table>
      <!--／年表 Simple-->
      <!--年表 Rich-->
      <div v-else-if="content.type=='rich'">
        <v-layout row wrap v-for="(row,id) in tips" :key="id" style="border-top:solid 1px #ddd;padding: 15px 0;">
          <v-flex xs2>
            <div class="nen"><v-chip>{{row.year | displayYear}}</v-chip></div>
            <div style="width:70%;height:90%;border-right:dotted 2px #aaa; margin-top:10px;"></div>
          </v-flex>
          <v-flex xs10>
            <v-card flat>
              <!-- 共同編集の場合はプロフィール出す -->
              <v-list-tile v-if="content.coEdit" avatar @click="onProfileClick(row.uid)">
                <v-list-tile-avatar size="40" style="z-index:2;" class="coEditProfile">
                  <img :src="row.profileImageUrl">
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title v-html="row.displayName" @click="onProfileClick(row.uid)"></v-list-tile-title>
                  <v-list-tile-sub-title v-html="$options.filters.displayDate(row.timestamp)"></v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <!-- ／共同編集の場合はプロフィール出す -->
              <v-img @click="onImagePush(row.imageUrl)" v-if="row.imageUrl" :src="row.imageUrl" max-height="400px" aspect-ratio="1"></v-img>
              <v-card-title primary-title style="padding-top:0px;">
                <h3 class="headline" style="width:100%;" v-if="row.title.length>0">{{row.title}}</h3>
                <div style="width:100%;" v-html="$options.filters.changeBr(row.content)"  v-if="row.content.length>0"></div>
                <div style="width:100%;" v-if="row.referUrl !== '' && !row.isYoutube"><a :href="row.referUrl" target="_blank">Link：{{row.referUrl}}</a></div>
                <youtube v-if="row.isYoutube" :video-id="row.youtubeId" :resize=true></youtube>
                <v-card-actions v-if="content.coEdit && uid === row.uid">
                  <v-btn flat color="red" block @click="onTipEdit(row)"><v-icon>edit</v-icon>編集する</v-btn>
                  <v-btn flat color="red" @click="onTipDelete(row)"><v-icon>close</v-icon>削除する</v-btn>
                </v-card-actions>
              </v-card-title>
            </v-card>
          </v-flex>
        </v-layout>
      </div>
      <!--／年表 Rich-->
      <div class="block" v-if="content.message.length>0" v-html="$options.filters.changeBr(content.message)"></div>
      <!-- 共同編集ボタン-->
      <v-layout row v-if="content.coEdit">
        <v-flex xs6><v-chip label dark color="red accent-1" large>みんなの年表</v-chip></v-flex>
        <v-flex xs6 style="text-align:right">
          <v-btn color="red" outline small @click="onTipAdd"><v-icon small>edit</v-icon>&nbsp;できごと追加</v-btn>
        </v-flex>
      </v-layout>
      <div v-if="content.coEdit" class="block" @click="onTipAdd">
        <div class="coEditBtn">
          <v-layout row style="margin: 10px 10px 0px 10px;">
            <v-flex xs4 class="topIcon">
              <v-avatar :size="70" color="grey lighten-4">
                <v-icon large>edit</v-icon>
              </v-avatar>
            </v-flex>
            <v-flex xs8>
              <p class="topName">できごとを追加する</p>
            </v-flex>
          </v-layout>
          <p style="margin: 0px 10px 10px 10px;text-align:center">
            この年表はみんなで編集する年表です。<br>
            １つからでも、あなたの大切な想い出を。
          </p>
        </div>
      </div>
      <!-- この年表を書いた人 -->
      <div class="block">
        <h3 v-if="content.coEdit">この年表の主</h3>
        <h3 v-else>この年表を書いた人</h3>
        <div class="editor">
          <v-layout row style="margin: 10px 10px 0px 10px;">
            <v-flex xs4 class="topIcon">
              <v-avatar :size="70" color="grey lighten-4" @click="onProfileClick(content.uid)">
                <img :src="userInfo.photoURL">
              </v-avatar>
            </v-flex>
            <v-flex xs8>
              <p class="topName" @click="onProfileClick(content.uid)">{{userInfo.displayName}}</p>
              <p v-if="userInfo.url" style="margin-bottom:4px;"><a :href="userInfo.url"><v-icon>link</v-icon>&nbsp;URL</a></p>
            </v-flex>
          </v-layout>
          <p v-if="userInfo.introduction" v-html="$options.filters.changeBr(userInfo.introduction)" style="margin: 0px 10px 10px 10px;"></p>
          <p v-if="idOwner" style="width:100%;text-align:center;padding:0;margin:0;"><v-btn color="red" outline @click="onEditProfile"><v-icon>edit</v-icon>&nbsp;プロフィール編集</v-btn></p>
        </div>
      </div>
      <!-- ／この年表を書いた人 -->
      <hr class="separator">
      <div v-if="idOwner">
        <v-btn color="red" block dark @click="onEdit"><v-icon>edit</v-icon>&nbsp;年表を編集する</v-btn>
        <p style="text-align:center">※「編集する」ボタンは投稿者にしか表示されません。</p>
      </div>
      <v-btn color="light-blue" block dark @click="onTwitterShareClick"><i class="fab fa-twitter"></i>&nbsp;この年表をシェアする</v-btn>
      <p v-if="!idOwner" style="text-align:center">おもしろい！と思ったらシェアしよう！！</p>
      <p v-else style="text-align:center">Twitterでシェアして盛り上がろう！</p>
      <hr class="separator">
      <div>
        <p class="title" style="margin-top:24px;"><v-icon>edit</v-icon>コメント</p>
        <textarea placeholder="コメントをどうぞ！！" rows="4" v-model="myComment" class="message"></textarea>
        <v-btn v-if="isLogin" color="red" dark block @click="onCommentSubmit">コメントを投稿する</v-btn>
        <p v-else style="text-align:center;">※コメントを残すには<router-link :to="{name: 'Login'}">ログイン</router-link>が必要です。</p>
      </div>
      <div class="comment-wrapper" v-for="(c, id) in comments" :key=id>
        <v-list-tile avatar>
          <v-list-tile-avatar>
           <img :src="c.profileImageUrl">
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title v-html="c.displayName"></v-list-tile-title>
            <v-list-tile-sub-title>{{c.timestamp | displayDate}}</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <p class="comment-content" v-html="$options.filters.changeBr(c.content)">
          {{c.content}}
        </p>
      </div>
      <div v-if="!isLoading" style="width:100%;text-align:center;">
        <v-btn v-if="!isCommentMax" color="red" large dark @click="onCommentMore">もっと見る</v-btn>
      </div>
      <hr class="separator">
      <!-- おすすめ年表-->
      <div class="block">
        <h3>こちらもおススメ</h3>
        <!-- <v-list two-line v-if="records.length>0">
        <template v-for="(r,id) in records">
        <v-list-tile :key="id" avatar @click="onRecordClick(r.id)" class="record-wrapper" style="height:85px;">
          <v-list-tile-avatar tile size="70">
            <v-img :src="r.imageUrl" aspect-ratio="1"></v-img>
          </v-list-tile-avatar>
          <v-list-tile-content style="height:85px;">
            <v-list-tile-sub-title style="height:36px;">
              <v-chip v-if="r.coEdit" dark color="red accent-1" small>みんなの年表</v-chip>
              <strong v-else style="font-size:120%;">{{r.displayName}}</strong>
               {{r.timestamp | displayDate}}
              <v-chip v-if="r.coEdit && r.tips_count" dark color="orange" small outline>投稿:{{r.tips_count}}</v-chip>
            </v-list-tile-sub-title>
            <v-list-tile-title v-html="r.title + 'の年表'" class="mincho title"></v-list-tile-title>
            <v-list-tile-sub-title style="height:40px;">
              <v-chip v-if="r.comment_count>0" small label outline color="red accent-1">
                <v-icon small>comment</v-icon>&nbsp;{{r.comment_count}}
              </v-chip>
              {{r.text}}
            </v-list-tile-sub-title>
          </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list> -->
        <v-layout row wrap v-for="(r,id) in records" :key=id style="margin-bottom:5px" @click="onRecordClick(r.id)">
          <div style="width:35%;">
            <v-img :src="r.imageUrl" aspect-ratio="1"></v-img>
          </div>
          <div style="width:65%;padding:0 5px;">
            <p>
              <v-chip v-if="r.coEdit" dark color="red accent-1" small>みんなの年表</v-chip>
              <strong v-else style="font-size:120%;">{{r.displayName}}</strong>
                {{r.timestamp | displayDate}}
              <v-chip v-if="r.coEdit && r.tips_count" dark color="orange" small outline>{{r.tips_count}}</v-chip>
            </p>
            <p style="word-wrap: break-word;">
              <span class="headline">{{r.title + 'の年表'}}</span>
            </p>
            <v-chip v-if="r.comment_count>0" small label outline color="red accent-1">
              <v-icon small>comment</v-icon>&nbsp;{{r.comment_count}}
            </v-chip>
          </div>
        </v-layout>
      </div>
      <!-- /おすすめ年表-->
      <!-- 年表一覧へ -->
      <div class="block" @click="onMoreNenpyo">
        <div class="editor">
          <v-layout row style="margin: 10px 10px 0px 10px;">
            <v-flex xs12>
              <p style="margin-top:20px;margin-bottom:5px;text-align:center;font-size:150%;font-weight:bold;"><v-icon large>search</v-icon>もっと年表を見る</p>
              <p style="padding:10px;">平成年表には懐かしい年表が投稿されています。ほかの年表も見てみよう。</p>
            </v-flex>
          </v-layout>
        </div>
      </div>
      <div class="block" @click="onAddNenpyo">
        <div class="editor">
          <v-layout row style="margin: 10px 10px 0px 10px;">
            <v-flex xs12>
              <p style="margin-top:20px;margin-bottom:5px;text-align:center;font-size:150%;font-weight:bold;"><v-icon large>edit</v-icon>想い出を年表にしませんか？</p>
              <p style="padding:10px;">平成年表は手軽に想い出を年表に出来るサービスです。あなたの想い出を年表にして投稿してみよう！</p>
            </v-flex>
          </v-layout>
        </div>
      </div>

    </div>
    <div v-else style="height:500px;width:100%;text-align:center;">
      <v-progress-circular v-show="isLoading" :size="70" :width="7" color="red" indeterminate style="margin-top:100px;"></v-progress-circular>
    </div>
    <v-dialog v-model="imageDialog" max-width="350px">
      <v-card><v-card-text style="text-align:center;">
        <img :src="upImage" style="max-height:90%;max-width:90%;">
      </v-card-text></v-card>
    </v-dialog>
    <common-footer></common-footer>
  </div>
</template>

<script>
import { db } from '../main'
import firebase from 'firebase'
import CommonHeader from './common/CommomHeader'
import CommonFooter from './common/CommomFooter'
const nens = ['平成元年', '平成2年', '平成3年', '平成4年', '平成5年', '平成6年', '平成7年', '平成8年', '平成9年', '平成10年', '平成11年', '平成12年', '平成13年', '平成14年', '平成15年', '平成16年', '平成17年', '平成18年', '平成19年', '平成20年', '平成21年', '平成22年', '平成23年', '平成24年', '平成25年', '平成26年', '平成27年', '平成28年', '平成29年', '平成30年', '平成31年', '令和元年', '令和2年']
export default {
  name: 'Chronology',
  data () {
    return {
      id: '',
      content: {title: ''},
      isError: false,
      errorMessage: '',
      isLoading: true,
      commentLimit: 20,
      comments: [],
      lastComment: undefined,
      isCommentMax: false,
      myComment: '',
      isCommentPosting: false,
      imageUrl: '',
      isImageLoading: false,
      tips: [],
      imageDialog: false,
      upImage: '',
      userInfo: {},
      users: [],
      fromSns: false,
      records: []
    }
  },
  head: {
    title: function () {
      return {
        inner: this.content.title + 'の年表',
        separator: '|',
        complement: '平成年表'
      }
    },
    meta: function () {
      return [
        {name: 'twitter:title', content: this.content.title + 'の年表｜平成年表'},
        {property: 'og:title', content: this.content.title + 'の年表｜平成年表'},
        {name: 'twitter:description', content: this.content.message},
        {name: 'keywords', content: this.content.title},
        {name: 'description', content: this.content.message}
      ]
    }
  },
  computed: {
    isLogin () {
      return this.$store.state.view.isLogin
    },
    hasImage () {
      if (this.content.image === undefined) {
        return false
      } else {
        return true
      }
    },
    profileImageUrl () {
      return this.$store.state.view.profileImageUrl
    },
    uid () {
      if (this.isLogin) {
        return firebase.auth().currentUser.uid
      } else {
        return 'notLogin'
      }
    },
    displayDate () {
      let date = new Date()
      let now = date.getTime()
      date.setTime(this.content.timestamp.seconds * 1000)
      let diff = (now - this.content.timestamp.seconds * 1000) / (60 * 1000) // 分
      if (diff < 60) {
        return `${Math.floor(diff)}分前`
      } else if (diff < 24 * 60) {
        return `${Math.floor(diff / 60)}時間前`
      } else {
        return `${date.getMonth() + 1}月${date.getDate()}日`
      }
    },
    idOwner () {
      if (this.isLogin && this.content.uid === firebase.auth().currentUser.uid) return true
      return false
    }
  },
  created () {
    if (this.$route.query.id) {
      this.$router.replace('/c/' + this.$route.query.id)
    }
    this.reload(this.$route.params.id)
  },
  watch: {
    '$route' (to, from) {
      if (to.params.id !== undefined && this.id !== to.params.id) {
        this.reload(to.params.id)
      }
    }
  },
  mounted () {
  },
  methods: {
    reload (id) {
      this.id = id
      this.comments = []
      this.lastComment = undefined
      this.isCommentMax = false
      this.refresh()
      this.commentRefresh()
    },
    refresh () {
      db.collection('chronology').doc(this.id).get().then((doc) => {
        if (doc.exists) {
          this.content = doc.data()
          this.isLoading = false
          this.$emit('updateHead')
          if (this.hasImage) {
            this.isImageLoading = true
            let fname = `chronology/${this.id}/${this.content.image}`
            let encodeFname = encodeURIComponent(fname)
            let imageUrl = `https://firebasestorage.googleapis.com/v0/b/heisei.appspot.com/o/${encodeFname}?alt=media`
            this.imageUrl = imageUrl
            this.content.imageUrl = imageUrl
            this.isImageLoading = false
          }
          if (this.content.type === 'rich') {
            if (this.content.isView) {
              this.getRowsByView()
            } else {
              this.getRows()
            }
          }
          this.getUserInfo()
          this.getOther()
        } else {
          this.isError = true
          this.errorMessage = '存在しないURLです。'
        }
      })
    },
    onProfileClick (id) {
      this.$router.push({name: 'Profile', params: {id: id}})
    },
    getImageUrl () {
      let storageRef = firebase.storage().ref()
      storageRef.child('chronology/' + this.id + '/' + this.content.image).getDownloadURL().then((imageurl) => {
        this.imageUrl = imageurl
        this.content.imageUrl = imageurl
        this.isImageLoading = false
      })
    },
    getRows () {
      this.tips = []
      db.collection('chronology').doc(this.id).collection('tips').orderBy('year', 'asc').orderBy('timestamp', 'asc').get().then((snapshot) => {
        snapshot.forEach((doc) => {
          let obj = doc.data()
          obj.id = doc.id
          obj = this.editObj(obj)
          this.tips.push(obj)
        })
        this.makeEditUserList()
      })
    },
    getRowsByView () {
      this.tips = []
      db.collection('chronology').doc(this.id).collection('view').doc('tips').get().then((doc) => {
        let objList = doc.data().list
        for (let i = 0; i < objList.length; i++) {
          let obj = objList[i]
          obj = this.editObj(obj)
          this.tips.push(obj)
        }
        this.makeEditUserList()
      })
    },
    editObj (obj) {
      if (obj.image !== undefined) {
        let fname = `chronology/${this.id}/${obj.image}`
        let encodeFname = encodeURIComponent(fname)
        let imageUrl = `https://firebasestorage.googleapis.com/v0/b/heisei.appspot.com/o/${encodeFname}?alt=media`
        obj.imageUrl = imageUrl
      }
      if (obj.referUrl !== '') {
        // youtube対応
        let url = obj.referUrl
        let p1 = 'https://www.youtube.com/watch?v='
        let p2 = 'https://youtu.be/'
        if (url.indexOf(p1) !== -1) {
          let id = url.split('v=')[1]
          obj.isYoutube = true
          obj.youtubeId = id
        } else if (url.indexOf(p2) !== -1) {
          let id = url.split('be/')[1]
          obj.isYoutube = true
          obj.youtubeId = id
        } else {
          obj.isYoutube = false
        }
      }
      return obj
    },
    makeEditUserList () {
      this.users = []
      for (let i = 0; i < this.tips.length; i++) {
        let tip = this.tips[i]
        let flag = false
        for (let j = 0; j < this.users.length; j++) {
          if (this.users[j].uid === tip.uid) {
            this.users[j].count++
            flag = true
            break
          }
        }
        if (!flag) {
          this.users.push({
            uid: tip.uid,
            profileImageUrl: tip.profileImageUrl,
            displayName: tip.displayName,
            count: 1
          })
        }
      }
      this.users.sort(function (a, b) {
        if (a.count < b.count) return 1
        if (a.count > b.count) return -1
        return 0
      })
    },
    getUserInfo () {
      db.collection('user').doc(this.content.uid).get().then((doc) => {
        this.userInfo = doc.data()
      })
        .catch((e) => {
          this.isError = true
          this.errorMessage = '存在しないURLです。'
        })
    },
    commentRefresh () {
      this.isCommentLoading = true
      let commentRef = db.collection('userActions').doc(this.id).collection('comments').orderBy('timestamp', 'desc')
      if (this.lastComment !== undefined) {
        commentRef = commentRef.startAfter(this.lastComment)
      }
      commentRef.limit(this.commentLimit).get().then((snapshot) => {
        snapshot.forEach((doc) => {
          let obj = doc.data()
          obj.id = doc.id
          this.comments.push(obj)
        })
        if (snapshot.docs.length === this.commentLimit) {
          this.lastComment = snapshot.docs[snapshot.docs.length - 1]
          this.isCommentMax = false
        } else {
          this.isCommentMax = true
        }
        this.isCommentLoading = false
      })
    },
    onCommentUpdate () {
      this.comments = []
      this.lastComment = undefined
      this.commentRefresh()
    },
    onCommentMore () {
      this.commentRefresh()
    },
    onEdit () {
      let obj = {
        mode: 'edit',
        content: this.content,
        id: this.id
      }
      if (this.content.type === 'rich') {
        obj.tips = this.tips
        this.$router.push({name: 'Edit', params: {obj: obj}})
      } else {
        this.$router.push({name: 'EditSimple', params: {obj: obj}})
      }
    },
    onTwitterShareClick () {
      let urltext = location.href
      urltext = urltext.replace('/csns/', '/c/')
      let url = `http://twitter.com/share?url=${urltext}&hashtags=平成年表,平成&text=${this.content.title}の年表`
      location.href = url
    },
    onCommentSubmit () {
      if (!this.commentValidate()) return
      this.isCommentPosting = true
      let timestamp = new Date()
      db.collection('userActions').doc(this.id).collection('comments').add({
        content: this.myComment,
        timestamp: timestamp,
        uid: firebase.auth().currentUser.uid,
        displayName: this.$store.state.view.displayName,
        profileImageUrl: this.$store.state.view.profileImageUrl
      })
        .then((doc) => {
          alert('投稿ありがとうございます！！\r\nコメントを投稿しました。')
          this.isCommentPosting = false
          this.myComment = ''
          this.onCommentUpdate()
        })
        .catch(function (error) {
          alert('エラーです。申し訳ございません。\r\n再度保存をお願いいたします。')
          console.error(error)
          this.isLoading = false
        }.bind(this))
    },
    commentValidate () {
      if (this.myComment.length > 400) {
        alert('エラー\r\nコメントは400文字以内で入力をお願いします。')
        return false
      }
      if (this.myComment.length < 2) {
        alert('エラー\r\nコメント入力が少なすぎます。')
        return false
      }
      return true
    },
    onImagePush (imageUrl) {
      this.upImage = imageUrl
      this.imageDialog = true
    },
    onEditProfile () {
      this.$router.push({name: 'EditProfile', params: {obj: {id: this.content.uid, userInfo: this.userInfo}}})
    },
    onTipAdd () {
      this.$router.push({name: 'TipAdd', params: {obj: {id: this.id, chronology: this.content, mode: 'new'}}})
    },
    onTipEdit (tip) {
      this.$router.push({name: 'TipAdd', params: {obj: {id: this.id, chronology: this.content, mode: 'edit', tip: tip}}})
    },
    onTipDelete (tip) {
      let text = `「${tip.title}」を削除しますか？`
      if (confirm(text)) {
        db.collection('chronology').doc(this.id).collection('tips').doc(tip.id).delete().then(function () {
          this.getRows()
        }.bind(this)).catch(function (error) {
          console.error('Error removing document: ', error)
        })
      }
    },
    onMoreNenpyo () {
      this.$router.push({name: 'View'})
    },
    getOther () {
      this.records = []
      let limit = 6
      let dbRef = db.collection('chronology').where('release', '==', true)
      dbRef = dbRef.orderBy('timestamp', 'desc')
      dbRef.limit(limit).get().then((snapshot) => {
        snapshot.forEach((doc) => {
          let obj = doc.data()
          obj.id = doc.id
          if (this.id === obj.id) {
          } else {
            // サムネイル画像の設定
            if (obj.image) {
              let fname = `chronology/${doc.id}/${obj.image}`
              let encodeFname = encodeURIComponent(fname)
              let imageUrl = `https://firebasestorage.googleapis.com/v0/b/heisei.appspot.com/o/${encodeFname}?alt=media`
              obj.imageUrl = imageUrl
            } else {
              obj.imageUrl = 'https://www.katsulabo.com/heisei/image/icon2.png'
            }
            // 説明文の設定
            if (obj.introduction !== undefined && obj.introduction.length > 1) {
              obj.text = obj.introduction
            } else {
              obj.text = obj.message
            }
            this.records.push(obj)
          }
        })
      })
    },
    onRecordClick (id) {
      this.$router.push({name: 'Chronology', params: {id: id}})
    },
    onAddNenpyo () {
      this.$router.push({name: 'Edit', params: {obj: {mode: 'new'}}})
    }
  },
  filters: {
    changeBr: function (value) {
      return value.replace(/\r?\n/g, '<br>')
    },
    displayYear: function (value) {
      return nens[Number(value)]
    },
    displayDate (value) {
      let date = new Date()
      let now = date.getTime()
      date.setTime(value.seconds * 1000)
      let diff = (now - value.seconds * 1000) / (60 * 1000) // 分
      if (diff < 60) {
        return `${Math.floor(diff)}分前`
      } else if (diff < 24 * 60) {
        return `${Math.floor(diff / 60)}時間前`
      } else {
        return `${date.getMonth() + 1}月${date.getDate()}日`
      }
    }
  },
  components: {
    CommonHeader,
    CommonFooter
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url("../assets/css/common.css");
iframe {
  width: 100%;
  max-width: 650px; /* Also helpful. Optional. */
}
.wrapper{
  width: 100%;
  max-width: 600px;
  margin: 36px auto;
  padding: 0 10px;
}
.nenpyo{
  margin-top: 10px;
}
.content-title{
  font-family: 'Yu Mincho','游明朝' !important;
  font-size: 28pt;
}
.v-text-field__details{
  margin-bottom: 0px !important;
}
p.title{
  margin-bottom: 5px;
}

table{
  margin: 0 auto;
  max-width: 650px;
  width: 100%;
  border: none;
  border-top: solid 1px #666;
  border-bottom: solid 1px #666;
  border-collapse: separate;
  border-spacing: 0 10px;
  background: #fbfbfb;
}
th{
  vertical-align: middle;
  height: 53px;
  max-width: 124px;
  width: 25%;
  border-right: solid 1px #666;
  margin: 0;
  text-align: center;
  color: #333;
  font-size: 16px;
  font-weight: bold;
}
td{
  padding: 16px;
  max-width:75%;
  margin: 0;
  border: none;
  color: #666;
  font-size: 12px;
  text-align: left;
}
.block{
  margin: 24px auto 0 auto;
  max-width: 650px;
  width: 100%;
}

textarea{
  border: solid 1px #9f9f9f;
  border-radius: 5px;
  width: 100%;
  height: 70px;
  padding-left: 5px;
  font-size: 110%;
}
.comment-wrapper{
  border: solid 1px #cfcfcf;
  border-radius: 10px;
  margin-top: 20px;
}
.comment-content{
  width: 90%;
  margin-left: 5%;
}
.nen{
  position: absolute;
  font-weight: bold;
  font-size: 130%;
  z-index: 2;
}
.editor{
  border: solid 1px #cfcfcf;
  border-radius: 10px;
}
.coEditBtn{
  border: solid 2px #FFCDD2;
  border-radius: 10px;
}
.topName{
  margin-top: 20px;
  margin-bottom: 5px;
  font-size: 140%;
  font-weight: bold;
}
.editor a {
  text-decoration: none;
}
.coEditProfile {
  min-width:45px;
}
.v-list__tile__title {
  height: 30px !important;
  padding-top: 4px;
}
.record-wrapper{
  padding-bottom:10px;
  margin-bottom: 10px;
  margin-top: 10px;
  border-bottom: 1px dashed #bbb;
}
.v-list__tile__avatar {
  min-width:76px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Chronology.vue